/**
 * RESPONSIBILITY: draw the mission and the vision together.
 *
 * Two columns that become one on a narrow screen, because they are read as a pair and a
 * pair read one under the other on a phone is still a pair.
 */
import { Html } from '@framework/react';
import type { AboutPurposeSection } from '@app/sections';

export function AboutPurpose({ c }: { c: AboutPurposeSection }) {
  return (
    <section className="band band-tint">
      <div className="wrap about-pair">
        <div className="stack">
          <h2>{c.missionHeading}</h2>
          {c.missionHtml && <Html className="md-body lede">{c.missionHtml}</Html>}
        </div>
        <div className="stack">
          <h2>{c.visionHeading}</h2>
          {c.visionHtml && <Html className="md-body lede">{c.visionHtml}</Html>}
        </div>
      </div>
    </section>
  );
}
